export const VERION_APP = 'v1.0.0'

export const COLOR_PRIMARY = '#3B4376'
export const COLOR_PRIMARY_SOFT = '#3b437630'
export const GRAY_TEXT = '#111'

export const STORAGE_NAMES = {
  DATE: 'loadedDate',
  CANTERAS: 'canteras',
  PRODUCTS: 'products',
  CLIENTS: 'clients',
  VOLCOS: 'volcos',
  NAMTRIK_FORM: 'namtrik_form',
}

export const STATUS_VENTA = {
  CERRADA: 'CERRADA',
  ABIERTA: 'ABIERTA',
  ANULADA: 'ANULADA',
} as const

export const EVENT_SERVICE_WORKER_NAME = 'swUpdated' as const
export const MSG_SKIP_WAITING = 'SKIP_WAITING' as const

export const ALL_PERMISSIONS = {
  PUEDE_AGREGAR_UNA_ENTRADA_DE_REGISTRO: 'add_logentry',
  PUEDE_CAMBIAR_LA_ENTRADA_DEL_REGISTRO: 'change_logentry',
  PUEDE_ELIMINAR_LA_ENTRADA_DEL_REGISTRO: 'delete_logentry',
  PUEDE_VER_LA_ENTRADA_DEL_REGISTRO: 'view_logentry',
  PUEDE_AGREGAR_PERMISO: 'add_permission',
  PUEDE_CAMBIAR_EL_PERMISO: 'change_permission',
  PUEDE_ELIMINAR_EL_PERMISO: 'delete_permission',
  PUEDE_VER_EL_PERMISO: 'view_permission',
  PUEDE_AGREGAR_GRUPO: 'add_group',
  PUEDE_CAMBIAR_DE_GRUPO: 'change_group',
  PUEDE_ELIMINAR_GRUPO: 'delete_group',
  PUEDE_VER_EL_GRUPO: 'view_group',
  PUEDE_AGREGAR_TIPO_DE_CONTENIDO: 'add_contenttype',
  PUEDE_CAMBIAR_EL_TIPO_DE_CONTENIDO: 'change_contenttype',
  PUEDE_ELIMINAR_EL_TIPO_DE_CONTENIDO: 'delete_contenttype',
  PUEDE_VER_EL_TIPO_DE_CONTENIDO: 'view_contenttype',
  PUEDE_AGREGAR_SESIÓN: 'add_session',
  PUEDE_CAMBIAR_DE_SESIÓN: 'change_session',
  PUEDE_ELIMINAR_SESIÓN: 'delete_session',
  PUEDE_VER_LA_SESIÓN: 'view_session',
  PUEDE_AGREGAR_USUARIO: 'add_customuser',
  PUEDE_CAMBIAR_USUARIO: 'change_customuser',
  PUEDE_ELIMINAR_USUARIO: 'delete_customuser',
  PUEDE_VER_USUARIO: 'view_customuser',
  PUEDE_AGREGAR_UN_TOKEN_DE_ACTUALIZACIÓN: 'add_refreshtoken',
  PUEDE_CAMBIAR_EL_TOKEN_DE_ACTUALIZACIÓN: 'change_refreshtoken',
  PUEDE_ELIMINAR_EL_TOKEN_DE_ACTUALIZACIÓN: 'delete_refreshtoken',
  PUEDE_VER_EL_TOKEN_DE_ACTUALIZACIÓN: 'view_refreshtoken',
  PUEDE_AGREGAR_VENTA: 'add_sale',
  PUEDE_CAMBIAR_VENTA: 'change_sale',
  PUEDE_ELIMINAR_VENTA: 'delete_sale',
  PUEDE_VER_VENTA: 'view_sale',
  PUEDE_AGREGAR_ORGANIZACIÓN: 'add_organization',
  PUEDE_CAMBIAR_LA_ORGANIZACIÓN: 'change_organization',
  PUEDE_ELIMINAR_ORGANIZACIÓN: 'delete_organization',
  PUEDE_VER_ORGANIZACIÓN: 'view_organization',
  PUEDE_AGREGAR_TRANSPORTE: 'add_transport',
  PUEDE_CAMBIAR_TRANSPORTE: 'change_transport',
  PUEDE_ELIMINAR_TRANSPORTE: 'delete_transport',
  PUEDE_VER_TRANSPORTE: 'view_transport',
  PUEDE_AGREGAR_PRODUCTO: 'add_product',
  PUEDE_CAMBIAR_PRODUCTO: 'change_product',
  PUEDE_ELIMINAR_PRODUCTO: 'delete_product',
  PUEDE_VER_EL_PRODUCTO: 'view_product',
  PUEDE_AGREGAR_CLIENTE: 'add_client',
  PUEDE_CAMBIAR_DE_CLIENTE: 'change_client',
  PUEDE_ELIMINAR_CLIENTE: 'delete_client',
  PUEDE_VER_CLIENTE: 'view_client',
  PUEDE_AGREGAR_CANTERA: 'add_quarry',
  PUEDE_CAMBIAR_CANTERA: 'change_quarry',
  PUEDE_BORRAR_CANTERA: 'delete_quarry',
  PUEDE_VER_CANTERA: 'view_quarry',
  PUEDE_AGREGAR_PRODUCTO_EN_OFERTA_MEDIANTE: 'add_saleproductthrough',
  PUEDE_CAMBIAR_EL_PRODUCTO_EN_OFERTA_MEDIANTE: 'change_saleproductthrough',
  PUEDE_ELIMINAR_EL_PRODUCTO_EN_OFERTA_MEDIANTE: 'delete_saleproductthrough',
  PUEDE_VER_EL_PRODUCTO_EN_OFERTA_A_TRAVÉS_DE: 'view_saleproductthrough',
  PUEDE_AGREGAR_DESPACHO: 'add_dispatch',
  PUEDE_CAMBIAR_DESPACHO: 'change_dispatch',
  PUEDE_BORRAR_DESPACHO: 'delete_dispatch',
  PUEDE_VER_DESPACHO: 'view_dispatch',
  PUEDE_AGREGAR_VENTA_DE_DESPACHO_MEDIANTE: 'add_dispatchsalethrough',
  PUEDE_CAMBIAR_LA_VENTA_DE_DESPACHO_MEDIANTE: 'change_dispatchsalethrough',
  PUEDE_ELIMINAR_LA_VENTA_DE_ENVÍO_MEDIANTE: 'delete_dispatchsalethrough',
  PUEDE_VER_LA_VENTA_DE_DESPACHO_A_TRAVÉS_DE: 'view_dispatchsalethrough',
  PUEDE_AGREGAR_PRODUCTO_DE_ENVÍO_A_TRAVÉS: 'add_dispatchproductthrough',
  PUEDE_CAMBIAR_EL_PRODUCTO_DE_ENVÍO_MEDIANTE: 'change_dispatchproductthrough',
  PUEDE_ELIMINAR_EL_PRODUCTO_ENVIADO_MEDIANTE: 'delete_dispatchproductthrough',
  PUEDE_VER_EL_PRODUCTO_ENVIADO_A_TRAVÉS_DE: 'view_dispatchproductthrough',
  PUEDE_AGREGAR_ENVÍO: 'add_delivery',
  PUEDE_CAMBIAR_EL_ENVÍO: 'change_delivery',
  PUEDE_BORRAR_ENVÍO: 'delete_delivery',
  PUEDE_VER_ENVÍO: 'view_delivery',
  PUEDE_AGREGAR_FORMULARIO: 'add_form',
  PUEDE_CAMBIAR_FORMULARIO: 'change_form',
  PUEDE_BORRAR_EL_FORMULARIO: 'delete_form',
  PUEDE_VER_EL_FORMULARIO: 'view_form',
  PUEDE_AGREGAR_SECCIÓN: 'add_section',
  PUEDE_CAMBIAR_SECCIÓN: 'change_section',
  PUEDE_ELIMINAR_SECCIÓN: 'delete_section',
  PUEDE_VER_SECCIÓN: 'view_section',
  PUEDE_AGREGAR_RESPUESTA: 'add_answer',
  PUEDE_CAMBIAR_LA_RESPUESTA: 'change_answer',
  PUEDE_ELIMINAR_LA_RESPUESTA: 'delete_response',
  PUEDE_VER_LA_RESPUESTA: 'view_answer',
  PUEDE_BORRAR_LA_RESPUESTA: 'delete_answer',
  PUEDE_AGREGAR_ENTIDAD: 'add_entity',
  PUEDE_CAMBIAR_DE_ENTIDAD: 'change_entity',
  PUEDE_ELIMINAR_ENTIDAD: 'delete_entity',
  PUEDE_VER_ENTIDAD: 'view_entity',
  PUEDE_AGREGAR_RESPUESTA_DE_ENTIDAD_A_TRAVÉS_DE: 'add_entityresponsethroguh',
  PUEDE_CAMBIAR_LA_RESPUESTA_DE_LA_ENTIDAD: 'change_entityresponsethroguh',
  PUEDE_ELIMINAR_LA_RESPUESTA_DE_LA_ENTIDAD_A_TRAVÉS_DE: 'delete_entityresponsethroguh',
  PUEDE_VER_LA_RESPUESTA_DE_LA_ENTIDAD_A_TRAVÉS_DE: 'view_entityresponsethroguh',
  PUEDE_AGREGAR_UN_FORMULARIO_DE_ENTIDAD_MEDIANTE: 'add_entityformthrough',
  PUEDE_CAMBIAR_LA_FORMA_DE_LA_ENTIDAD: 'change_entityformthrough',
  PUEDE_ELIMINAR_EL_FORMULARIO_DE_ENTIDAD_MEDIANTE: 'delete_entityformthrough',
  PUEDE_VER_EL_FORMULARIO_DE_LA_ENTIDAD_A_TRAVÉS_DE: 'view_entityformthrough',
  PUEDE_AGREGAR_CAMPO: 'add_fieldsection',
  PUEDE_CAMBIAR_DE_CAMPO: 'change_fieldsection',
  PUEDE_BORRAR_CAMPO: 'delete_fieldsection',
  PUEDE_VER_EL_CAMPO: 'view_fieldsection',
  PUEDE_VER_INFORMES: 'view_reports',
} as const
